import { axiosClient } from "auth-sdk";
import { ProductRequestSchemas } from "api-types";

export const NEW_OFFERS_REQUEST_STATUS_QUERY_KEY = "new-offers-request-status";

export const getNewOffersRequestStatusQueryOptions = (customerDomain: string, productRequestId: string) => {
  const url = `/${customerDomain}/product-request/api/${productRequestId}/new-offers-request-status`;

  return {
    queryKey: [NEW_OFFERS_REQUEST_STATUS_QUERY_KEY, customerDomain, productRequestId],
    queryFn: () => axiosClient.get<ProductRequestSchemas.NewOffersRequestStatusResponse>(url),
    select: ({ data }): ProductRequestSchemas.NewOffersRequestStatusResponse => data,
  };
};
